import { fabric } from "fabric";
import { IObjectOptions } from "fabric/fabric-impl";
import { AnnotationObjectDefaultProperties, ShapeGetData, ShapeOptions } from "./annotation-type";

export class Rectangle extends fabric.Rect implements ShapeGetData {
	constructor(private options: ShapeOptions, objectOptions?: IObjectOptions) {
		super({
			...objectOptions,
			...AnnotationObjectDefaultProperties,
			left: options.x,
			top: options.y,
			stroke: options.color,
			width: options.width,
			height: options.height,
			angle: options.rotate,
			fill: options.fill,
			opacity: options.opacity,
			originX: "center",
			originY: "center"
		});
	}

	public setData(update: Partial<ShapeOptions>): void {
		Object.assign(this.options, update);

		this.setOptions({
			left: this.options.x,
			top: this.options.y,
			stroke: this.options.color,
			width: this.options.width,
			height: this.options.height,
			angle: this.options.rotate
		});
	}

	public getData(): ShapeOptions {
		const w = this.width!;
		const h = this.height!;
		const scaleX = this.scaleX!;
		const scaleY = this.scaleY!;
		return {
			type: this.options.type,
			width: w * scaleX,
			height: h * scaleY,
			x: this.left!,
			y: this.top!,
			color: this.stroke!,
			rotate: this.angle || 0,
			fill: this.fill,
			opacity: this.opacity!
		};
	}
}
